import { ICONS } from '../../constants/icons/icons.constant'

import * as historyActiveLs from '../../assets/mobile/landscape/menu-footer/history/mb-ls-btn-bright-history-active.png'
import * as spinSettingsActiveLs from '../../assets/mobile/landscape/menu-footer/spin/mb-ls-btn-bright-spin-active.png'

/**
 * @file Defines the {@link MENU_BUTTON_CONFIG} constant
 * @author Joe Thompson <joe.thompson@1x2network.com>
 * @type {object}
 * @constant
 * @default
 * @property {menu-button-config-setting} home         - Home menu button config.
 * @property {menu-button-config-setting} guide        - Game guide button config.
 * @property {menu-button-config-setting} payout       - Payout button config.
 * @property {menu-button-config-setting} winWaysLines - Win ways/lines button config.
 * @property {menu-button-config-setting} history      - Game history button config.
 * @property {menu-button-config-setting} settings     - Settings button config.
 * @property {menu-button-config-setting} freespins    - Buy freespins button config.
 */
 export const MENU_BUTTON_CONFIG = {

     home: {

         img:      ICONS.home,
         optional: { check: { manager: 'framework', func: 'isTouch', override: () => { return !window.f1x2.clientWrapperInit.showLobby } }, id: 'home' },
         text:     [ 'Close the game and navigate to the lobby' ],

     },

     guide: {

         img:  ICONS.gameGuide,
         text: [ 'View help guide and controls' ],

     },

     payout: {

         img:  ICONS.payout,
         text: [ 'View symbol payouts' ],

     },

     winWaysLines: {

         img:  ICONS.winLinesWays,
         text: [ 'View winning combinations' ],
         optional: { check: { manager: 'loginVars', func: 'getGameParams', prop: 'gameID', condition: (v_) => { return [ 23, 24, 25, 26, 27, 28, 29, 31, 33, 34, 35 ].indexOf(Number(v_.slice(-2)) > -1) } }, id: 'win-ways' }

     },

     history: {

         img:  ICONS.history,
         mobImg: historyActiveLs,
         text: [ 'View previous bet details' ]

     },

     settings: {

         img:  ICONS.settings,
         mobImg: spinSettingsActiveLs,
         text: [ 'View in-game settings' ]

     },

     freespins: {

         custom:   true,
         img:      ICONS.freespins,
         optional: { check: { manager: 'communicationManager_', func: 'getResumeStatus', prop: 'disableBuyIn' }, id: 'buy-freespins' },
         text:     [ 'Purchase freespins in-game' ],

     }

 }